import React from 'react'
import { useNavigate } from 'react-router-dom'

const Home = () => {
  const navigate = useNavigate()
  const featureLink = (link, term) => {
    if (!term) term = link
    const tag = link.replace(/^[\W+]/, '')
    return (<i><b>
      <span
        className="text-primary text-center mouse-pointer"
        onClick={() => navigate(`/features#${tag}`)}
      >
        {term}
      </span>
    </b>
    </i>)
  }
  //        <h2 className="left-margin-3">Leverage (coming soon)...</h2>
  //        <h4 className="left-margin-5"><li>Explore { featureLink("integrations") } with common tools.</li></h4>
  //        <h4 className="left-margin-5"><li>Use the { featureLink("api", "open REST API") } and { featureLink("webhooks") } to implement custom integrations.</li></h4>

  return (
    <div className="margin-top-top border05 rounded1 padding2">
      <h1 className="left-margin-1 title text-muted">Do.What.Matters.</h1>
      <h2 className="left-margin-3">Decide what matters...</h2>
      <h4 className="left-margin-5">
        <li>Business leaders determine business {featureLink('priorities')}.</li>
      </h4>
      <h4 className="left-margin-5">
        <li>Team leads set team {featureLink('strategies')} to accomplish business priorities.</li>
      </h4>
      <h4 className="left-margin-5">
        <li>Team members set personal {featureLink('goals')} for their team strategies.</li>
      </h4>
      <h2 className="left-margin-3">Do it...</h2>
      <h4 className="left-margin-5">
        <li>Team members work their goals and {featureLink('journal')} their progress.</li>
      </h4>
      <h2 className="left-margin-3">Learn...</h2>
      <h4 className="left-margin-5">
        <li>Collaborate through {featureLink('comments')} and {featureLink('@mentions')}.</li>
      </h4>
      <h4 className="left-margin-5">
        <li>Make note of important updates using {featureLink('#hashtags')}.</li>
      </h4>
      <h4 className="left-margin-5">
        <li>{featureLink('follow', 'Follow')} progress toward goals, strategies, and priorities.</li>
      </h4>
      <h4 className="left-margin-5">
        <li>{featureLink('reports', 'Report')} on goals, strategies, and priorities.</li>
      </h4>
      <h4 className="left-margin-5">
        <li>Conduct insightful {featureLink('reviews', 'performance reviews')}.</li>
      </h4>
    </div>
  )
}

export default Home
